export class SelectData {
    protected _name: string;
    protected _id: string;

    get name(): string {
        return this._name;
    }

    get id(): string {
        return this._id;
    }
}